<template>
	<div :class="classes">
		<slot />
	</div>
</template>

<script lang="ts">
import { CSSClasses } from '@/common/types';
import { Component, Vue, Prop } from 'vue-facing-decorator';

export declare type HdlBadgeStyle = 'purple' | 'gray' | 'blue' | 'green' | 'default' | 'red';

@Component
export default class Banner extends Vue {
	@Prop({ default: 'default' })
	hdlStyle: HdlBadgeStyle;

	get classes(): CSSClasses {
		const result: CSSClasses = {
			'hdl-banner': true
		};

		result[this.hdlStyle] = true;

		return result;
	}
}
</script>

<style lang="scss">
.hdl-banner {
	@apply rounded flex flex-row items-center select-none p-4;

	&.default {
		@apply border border-border-gray;
	}

	&.purple {
		background: var(--purple-bg);
		color: var(--purple);
	}

	&.gray {
		background: var(--gray-bg);
		color: var(--dark-gray);
	}

	&.blue {
		background: var(--blue-bg);
		color: var(--blue);
	}

	&.red {
		background: var(--red-bg);
		color: var(--red);
	}

	&.green {
		background: var(--green-bg);
		color: var(--green);
	}
}
</style>
